var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "swiper",
    {
      ref: _vm.sliderRef,
      staticClass: "slider",
      class: _vm.customClass,
      attrs: { options: _vm.options },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }